import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockStatementModel } from './stock-statement-model';

export class StockStatementResponseModel extends GlobalResponseObject {
    data?: StockStatementModel;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: StockStatementModel){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}